import { render, staticRenderFns } from "./GerenciaScreenComision.vue?vue&type=template&id=2d9626f2"
import script from "./GerenciaScreenComision.vue?vue&type=script&lang=js"
export * from "./GerenciaScreenComision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports